<template>
  <div class="page-wrapper">
    <app-header></app-header>
    <section class="home-section">
      <video-graphic></video-graphic>
      <!-- <home-bubbles></home-bubbles> -->
      <div class="bg-holder">
        <video-bg :sources="[videoPath]" :img="videoImagePath"></video-bg>
      </div>
      <div class="container">
        <div class="row align-items-end">
          <div class="col-sm-9 col-md-6">
            <h3 class="mb-40 white">
              Effortless payment acceptance and instant processing on a scalable
              cloud environment.
            </h3>
            <div class="home-actions">
              <router-link to="/signup" class="btn mr-20 mb-20">Sign up now</router-link>
              <router-link to class="btn btn-outline all-white mb-20">View pricing</router-link>
            </div>
            <features-slider class="mt-100"></features-slider>
          </div>
          <!-- <div class="col-md-6">
            <div class="animated-hero mt-100 mt-md-0">
              <div class="back-image d-none d-md-block">
                <img class="right animate-float" src="@/assets/home-spaceship.svg" alt />
                <img class="left animate-float" src="@/assets/home-spaceship.svg" alt />
              </div>
              <img class="robot-arm animate-float" src="@/assets/home-robotarm.png" alt />
            </div>
          </div>-->
        </div>
      </div>
      <!-- <div class="left-rocks">
        <img src="@/assets/rocks.png" alt />
      </div>-->
    </section>

    <section class="section features-section">
      <div class="section-graphics">
        <svg id="ornament-border" x="0px" y="0px" width="1101.987px" height="624.003px" viewBox="0 0 1101.987 624.003" enable-background="new 0 0 1101.987 624.003" xml:space="preserve">
          <path fill-rule="evenodd" fill="none" stroke="#f1f1ee" stroke-width="2px" clip-rule="evenodd" d="M0,0h1101.987l-350.58,624.003H0V0z" />
        </svg>
        <svg id="ornament" x="0px" y="0px" width="854.031px" height="572.44px" viewBox="0 0 854.031 572.44" enable-background="new 0 0 854.031 572.44" xml:space="preserve">
          <path fill="#f1f1ee" fill-rule="evenodd" clip-rule="evenodd" d="M0,0h854.031L532.595,572.44H0V0z" />
        </svg>
      </div>
      <div class="container">
        <section-title class="mb-30">
          <template #subtitle>Experience our top level</template>
          <template #title>Merchant Services</template>
        </section-title>

        <hooper class="features-carousel" :settings="hooperSettings" ref="featuresCarousel">
          <slide>
            <feature-card imgSrc="processing.png">
              <template #title>
                Immediate
                <span class="primary-color">processing</span>
                <br />after signup
              </template>
              <template #description>After your intermediate registration, your kopplr token is directly accessible and you are able to charge your customers right away.</template>
            </feature-card>
          </slide>
          <slide>
            <feature-card imgSrc="dashboard.png">
              <template #title>
                All under control
                <br />with your
                <span class="primary-color">dashboard</span>
              </template>
              <template #description>At kopplr, intuitive design meets clever engineering. Through real-time data, insights, and reports, you can react faster.</template>
            </feature-card>
          </slide>
          <slide>
            <feature-card imgSrc="multicurrency.png">
              <template #title>
                <span class="primary-color">Crypto</span> acceptance for
                <br />the digital age
              </template>
              <template #description>Based on blockchain technology, our payment platform simplifies storage, transfer and trade of multiple currencies like never before.</template>
            </feature-card>
          </slide>
          <slide>
            <feature-card imgSrc="checkout.png">
              <template #title>
                Customized marketing
                <br />with
                <span class="primary-color">hot customer</span>
              </template>
              <template #description>With an AI backend, kopplr triggers your marketing events based on data enriching from transactions, which boosts the shop message.</template>
            </feature-card>
          </slide>
          <slide>
            <feature-card imgSrc="security.png">
              <template #title>
                Ensure the
                <span class="primary-color">security</span>
                <br />of your customers
              </template>
              <template #description>Through rigorous security checks, safe data storage and compliance with every available regulation, we can ensure the safety.</template>
            </feature-card>
          </slide>
        </hooper>

        <div class="hooper-controls">
          <button @click.prevent="previousSlide()">
            <i class="uil uil-arrow-left"></i>
          </button>
          <button @click.prevent="nextSlide()">
            <i class="uil uil-arrow-right"></i>
          </button>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-7">
            <social-icons></social-icons>
          </div>
        </div>
      </div>
    </section>

    <app-footer></app-footer>

    <transition name="drag-fade">
      <mobile-menu v-if="menuOpen"></mobile-menu>
    </transition>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { Hooper, Slide } from 'hooper'
import VideoBg from 'vue-videobg'

import Header from '@/components/Header.vue'
import VideoGraphic from '@/components/VideoGraphic.vue'
import MobileMenu from '@/components/MobileMenu.vue'
import FeaturesSlider from '@/components/FeaturesSlider.vue'
// import HomeBubbles from '@/components/HomeBubbles.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import FeatureCard from '@/components/FeatureCard.vue'
import SocialIcons from '@/components/SocialIcons.vue'
import Footer from '@/components/Footer.vue'

import HomeVideo from '@/assets/vid/home-video-bg.mp4'
import HomePoster from '@/assets/home-video-bg.jpg'

export default {
  name: 'home',
  components: {
    Hooper,
    Slide,
    'app-header': Header,
    VideoGraphic,
    MobileMenu,
    FeaturesSlider,
    // HomeBubbles,
    SectionTitle,
    FeatureCard,
    SocialIcons,
    'app-footer': Footer,
    'video-bg': VideoBg
  },
  computed: {
    ...mapFields({
      menuOpen: 'ui.menuOpen',
      slide: 'ui.slideNumber'
    })
  },
  data() {
    return {
      videoPath: HomeVideo,
      videoImagePath: HomePoster,
      hooperSettings: {
        autoPlay: true,
        playSpeed: 3000,
        transition: 600,
        itemsToShow: 1,
        itemsToSlide: 1,
        infiniteScroll: true,
        centerMode: true,
        wheelControl: false,
        keysControl: false,
        initialSlide: 2,
        breakpoints: {
          576: {
            itemsToShow: 2
          },
          768: {
            itemsToShow: 3
          }
        }
      }
    }
  },
  methods: {
    nextSlide() {
      this.$refs.featuresCarousel.slideNext()
    },
    previousSlide() {
      this.$refs.featuresCarousel.slidePrev()
    }
  }
}
</script>
